export const ECOMM_ELIGIBLE_ENTITIES = {
  EXPERIMENT: ['Eligible - Cables and Accessories Only', 'Ineligible - Contact Sales'],
  NO_EXPERIMENT: ['Ineligible', 'Eligible - Override', 'Eligible'],
  DEFAULT: 'Ineligible',
};